import { Component, Vue } from 'vue-property-decorator';

@Component
export default class ScrollEventMixin extends Vue {

    /**
     * The scroll rate applied before calling scroll event.
     */
    protected debounceRate = 70;

    /**
     * Method automatically called by the mixin.
     * Should be overriden to listen scroll events.
     */
    protected onScroll(): void {
        // Overriden by component
    }

    /**
     * Method automatically called by the mixin.
     * Should be overriden to listen debounced scroll events.
     */
    protected onScrollDebounced(): void {
        // Overriden by component
    }
    
    private scrollTimer?: number;

    created() {
      window.addEventListener('scroll', this.onScroll_);
    }
  
    destroyed() {
      window.removeEventListener('scroll', this.onScroll_);
    }

    private onScroll_() {
        // Directly call on scroll event.
        this.onScroll();
        // Handle debounced scroll events.
        if (this.scrollTimer === undefined) {
          this.scrollTimer = setTimeout(() => {
            this.scrollTimer = undefined;
            this.onScrollDebounced();
          }, this.debounceRate);
        }
    }
}